
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/validar-certificacion",
      function () {
        return require("private-next-pages/validar-certificacion/index.js");
      }
    ]);
  